import React from 'react';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import { useWindowSize } from '@Components/Utilities/WindowSize';

const LocalizedSimilarListings = (props) => {
    const windowSize = useWindowSize();

    return (
        <>
            {props?.SimilarListings?.length > 0 &&
                <div className='localized-divider'>
                    <div className={props.useGridView ? 'list-similar similar-split' : 'list-similar'}>
                        <h3>{props.ViewAllText}</h3>
                        <div className='similar-container'>
                            { /* Only take 2 results for mobile views--otherwise take all results */ }
                            {props.SimilarListings.filter((item, index) => !windowSize.isMobile || index < 2).map((listing, index) => {
                                return (<a className='similar-listings' href={listing.DetailUrl} key={`similar-link-${index}`}>
                                    <div className='similar-img'>
                                        <LazyLoadImage src={listing.ListingImageModel.ImageUrl?.[0] ?? ''} alt={listing.ListingTitle} />
                                    </div>
                                    <div className='similar-details'>
                                        <div className='similar-name'>{listing.ListingTitle}</div>
                                        <div className='similar-category'>{listing.DisplayCategoryName || listing.CategoryName}</div>
                                        <div className='similar-price'>{listing.RetailPrice}</div>
                                    </div>
                                </a>);
                            })}
                        </div>
                        <div className='similar-search-list'>
                            <ul>
                                {props.SimilarSearchSuggestions.map((search, index) => {
                                    return (
                                        <li key={`suggested-search-${index}`}>
                                            <a href={search.Url}>{search.DisplayText}</a>
                                        </li>);
                                })}
                            </ul>
                        </div>
                    </div>
                </div>
            }
        </>
    );
};

export default LocalizedSimilarListings;